import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  Stack,
  Autocomplete,
  Stepper,
  Step,
  StepLabel,
  Select,
  MenuItem,
} from "@mui/material"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { useState } from "react"
import dayjs from "dayjs"
import Modal from "../ui/Modal"
import { DatePicker } from "../ui/DateTimePickers"
import FormItem from "../ui/FormItem"
import { createBatch, getAllPrograms } from "../../api"
import { useSnackbar } from "notistack"

const steps = ["Batch details", "Create schedule", "Final preview"]

export default function AddBatchModal({
  isOpen,
  close,
  currentBatchDetails,
  refresh,
  currentProgramId,
  currentSemester,
  currentAcademicYear,
  openClassSchedule,
}) {
  const [activeStep, setActiveStep] = useState(0)

  const { enqueueSnackbar } = useSnackbar()

  const [selectedStartDate, handleStartDateChange] = useState(
    currentBatchDetails?.startDate || dayjs()
  )
  const [selectedEndDate, handleEndDateChange] = useState(
    currentBatchDetails?.endDate || dayjs()
  )
  const [name, setName] = useState(currentBatchDetails?.name || "")
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState("")
  const [academicYear, setAcademicYear] = useState(currentAcademicYear)
  const [semester, setSemester] = useState(currentSemester)
  const [programId, setProgramId] = useState(currentProgramId)
  const [programIdInput, setProgramIdInput] = useState()
  const [programs, setPrograms] = useState([])

  //! Do you need course id for creating batch??
  //todo const courseId = useParams().id

  const getPrograms = () => {
    getAllPrograms()
      .then((res) =>
        setPrograms(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
  }

  const handleSubmit = () => {
    setLoading(true)
    let formDetails = {
      name,
      code,
      academicYear,
      semester,
      //todo courseId,
      programId,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    }
    createBatch(formDetails)
      .then((res) => {
        enqueueSnackbar(`New Batch Added`, { variant: "success" })
        refresh()
        close()
        openClassSchedule()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      title="Add Batch"
      loading={loading}
      action={handleSubmit}
    >
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/*//* BATCH DETAILS */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Stack direction={"row"} spacing={2} alignItems="center">
                <FormItem label="Batch name">
                  <TextField
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </FormItem>
                <FormItem label="Batch code">
                  <TextField
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </FormItem>
              </Stack>
            </FormControl>
            <Stack direction={"row"} spacing={2} alignItems="center">
              <FormItem label="Academic Year">
                <TextField
                  value={academicYear}
                  onChange={(e) => setAcademicYear(e.target.value)}
                />
              </FormItem>
              <FormItem label="Semester">
                <Select
                  name="semester"
                  value={semester}
                  onChange={(event) => {
                    const { value } = event.target
                    setSemester(value)
                  }}
                >
                  {[...Array((currentBatchDetails?.numYear || 0) * 2).keys()].map((num) => (
                    <MenuItem key={num + 1} value={num + 1}>
                      {num + 1}
                    </MenuItem>
                  ))}
                </Select>
              </FormItem>
            </Stack>
            <Stack direction={"row"} spacing={2} alignItems="center">
              <FormItem label="Program">
                <Autocomplete
                  value={programIdInput}
                  sx={{ width: "100%" }}
                  onChange={(_, newValue) => {
                    setProgramId(newValue?.id)
                  }}
                  inputValue={programIdInput}
                  onInputChange={(_, newInputValue) => {
                    setProgramIdInput(newInputValue)
                    getPrograms(newInputValue)
                  }}
                  getOptionLabel={(option) => option.label || option}
                  options={programs}
                  renderInput={(params) => (
                    <TextField sx={{ width: "100%" }} {...params} />
                  )}
                />
              </FormItem>
            </Stack>
          </Grid>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <FormLabel> Starts on</FormLabel>
                <DatePicker
                  value={selectedStartDate}
                  onChange={(date) => handleStartDateChange(date)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <FormLabel>Ends on</FormLabel>
                <DatePicker
                  value={selectedEndDate}
                  onChange={(date) => handleEndDateChange(date)}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </LocalizationProvider>
    </Modal>
  )
}
